import React from "react"
import { Col, Row } from "reactstrap"
import NumberFormat from "../../../../utils/numberFormat"
const DebitAccountVoucherView = ({ tabledata, invoiceDetails }) => {
  const desimalrange = localStorage.getItem("desimalrange")

  const result = tabledata?.reduce(
    (acc, item) => {
      const received = item.received_quantity || 0
      return {
        totalreceived: Number(acc.totalreceived) + Number(received),
      }
    },
    { totalreceived: 0 }
  )

  const handilCalaculation2 = data => {
    const total = data
      ?.map(item => Number(item?.grn_quantity || 0))
      .reduce((sum, amount) => sum + amount, 0)
    return total
  }

  const handilCalaculationvat = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 17
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 17)
          ?.debit_amount || 0
      : 0
    return otherCharge
  }

  const handilCalaculation3 = data => {
    const total = data
      ?.map(
        item =>
          Number(item?.unit_price || 0) * Number(item?.voucher_quantity || 0)
      )
      .reduce((sum, amount) => sum + amount, 0)
    const totalvalue = total
    return totalvalue
  }

  const handilCalaculation4 = data => {
    const total = data
      ?.map(
        item => Number(item?.unit_price || 0) * Number(item?.po_quantity || 0)
      )
      .reduce((sum, amount) => sum + amount, 0)
    const totalvalue = total
    return totalvalue
  }

  const handilDiscound15 = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 25
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 25)
          ?.credit_amount || 0
      : 0
    return otherCharge
  }

  const handilCalaculation5 = data => {
    const qty = data
      ?.map(item => Number(item?.quantity || 0))
      .reduce((sum, amount) => sum + amount, 0)
    const total = data
      ?.map(item => Number(item?.rate || 0))
      .reduce((sum, amount) => sum + amount, 0)
    const totalvalue = qty * total
    return totalvalue
  }
  const handilCalaculationSale = data => {
    return data?.reduce((sum, item) => {
      const price = parseFloat(item?.unit_price || 0)
      const qty = parseFloat(item?.so_quantity || 0)
      return sum + price * qty
    }, 0)
  }

  const handilShipingCharg = data => {
    const journalEntryDetails = data?.some(detail => detail?.account_id == 3)
    const shippingCharge = journalEntryDetails
      ? data.find(detail => detail?.account_id == 3)?.debit_amount || 0
      : 0
    return shippingCharge
  }

  const handilOtherCharge = data => {
    const journalEntryDetails = data?.some(detail => detail?.account_id == 4)
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.account_id == 4)?.debit_amount || 0
      : 0
    return otherCharge
  }

  const handilRetention = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 4
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 2)
          ?.debit_amount || 0
      : 0
    return otherCharge
  }
  const handilAdvRetention = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 2
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 2)
          ?.debit_amount || 0
      : 0
    return otherCharge
  }

  const handilVatchange = data => {
    if (!Array.isArray(data)) return 0

    const match = data.find(detail => detail?.ledger?.account_group_id == 17)

    return match?.credit_amount || match?.debit_amount || 0
  }

  const handilDiscound = data => {
    const journalEntryDetails = data?.some(
      detail => detail?.ledger?.account_group_id == 25
    )
    const otherCharge = journalEntryDetails
      ? data.find(detail => detail?.ledger?.account_group_id == 25)
          ?.credit_amount || 0
      : 0
    return otherCharge
  }

  const handleContaAmounts = journalEntryDetails =>
    journalEntryDetails?.reduce(
      (sum, entry) => sum + (parseFloat(entry?.credit_amount) || 0),
      0
    )

  const getLastAmount = journalEntryDetails => {
    const lastEntry = journalEntryDetails[journalEntryDetails?.length - 1]
    return lastEntry?.credit_amount !== null
      ? parseFloat(lastEntry?.credit_amount)
      : parseFloat(lastEntry?.debit_amount) || 0
  }

  const { totalreceived } = result || {}

  // Sub Total
  const subTotal16 =
    invoiceDetails?.purchaseorder?.materials?.reduce(
      (sum, item) =>
        sum + Number(item?.po_quantity || 0) * Number(item?.unit_price || 0),
      0
    ) || 0

  // Discount
  const discount16 =
    (subTotal16 * Number(invoiceDetails?.discount || 0)) / 100 || 0

  // VAT
  const vat16 =
    ((subTotal16 - discount16) * Number(invoiceDetails?.vat || 0)) / 100 || 0

  // Shipping Charge
  const shipping16 = Number(invoiceDetails?.purchaseorder?.shipping_charge || 0)

  // Other Charges
  const other16 = Number(invoiceDetails?.purchaseorder?.other_charge || 0)

  // Net Total
  const netTotal16 = subTotal16 - discount16 + vat16 + shipping16 + other16

  return (
    <>
      <Row className="mt-4">
        <Col lg={12}>
          <h5 className="productDetail edittheamtitle">
            {invoiceDetails?.voucher_id == 1 ||
            invoiceDetails?.voucher_id == 3 ||
            invoiceDetails?.voucher_id == 6 ||
            invoiceDetails?.voucher_id == 8
              ? "Details"
              : invoiceDetails?.voucher_id == 13
              ? "Sales Detail"
              : "Material Details"}
          </h5>
        </Col>
        <Col lg={12}>
          <table className="estimation-table mb-4">
            <thead>
              <tr>
                <th>S No</th>
                <th>Account Head</th>
                <th className="text-end pe-5">Amount</th>
              </tr>
            </thead>
            <tbody>
              {invoiceDetails?.journalEntry?.journal_entry_details
                ?.slice(0, -1)
                .map((item, idx) => (
                  <tr key={item.id}>
                    <td className="ps-2">{idx + 1}</td>
                    <td>{item?.ledger_name || "-"}</td>
                    <td className="text-end pe-5">
                      {item?.credit_amount
                        ? NumberFormat(
                            -Math.abs(item?.credit_amount),
                            desimalrange,
                            desimalrange
                          )
                        : item?.debit_amount
                        ? NumberFormat(
                            item?.debit_amount,
                            desimalrange,
                            desimalrange
                          )
                        : NumberFormat(0.0)}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Col>
        {(invoiceDetails?.voucher_id == 15 &&
          Number(
            handilCalaculation3(invoiceDetails?.purchasevoucher?.materials)
          ) == 0) ||
        (invoiceDetails?.voucher_id == 16 &&
          Number(
            handilCalaculation4(invoiceDetails?.purchaseorder?.materials)
          ) == 0) ||
        (invoiceDetails?.voucher_id == 13 &&
          Number(invoiceDetails?.sub_total) == 0 &&
          invoiceDetails?.voucher_invoice != "Sales Account") ||
        (invoiceDetails?.voucher_id == 12 &&
          Number(handilCalaculation5(invoiceDetails?.storeHistory)) == 0) ? (
          <></>
        ) : (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">Sub Total</div>
                </Col>
                <Col lg="3" className="py-2">
                  {NumberFormat(
                    Number(
                      getLastAmount(
                        invoiceDetails?.journalEntry?.journal_entry_details ||
                          []
                      )
                    ),
                    desimalrange,
                    desimalrange
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        )}
        {invoiceDetails?.voucher_id == 13 &&
        invoiceDetails?.voucher_invoice == "Sales Invoice" &&
        handilRetention(invoiceDetails?.journalEntry?.journal_entry_details) >
          0 ? (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">
                    {invoiceDetails == null ? "" : "Retention"}
                  </div>
                </Col>
                <Col lg="3" className="py-2">
                  {invoiceDetails?.voucher_id == 13 ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        handilRetention(
                          invoiceDetails?.journalEntry?.journal_entry_details
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        {invoiceDetails?.voucher_id == 13 &&
        invoiceDetails?.voucher_invoice == "Sales Invoice" &&
        handilAdvRetention(
          invoiceDetails?.journalEntry?.journal_entry_details
        ) > 0 ? (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">
                    {invoiceDetails == null ? "" : "Advance Retention"}
                  </div>
                </Col>
                <Col lg="3" className="py-2">
                  {invoiceDetails?.voucher_id == 13 ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        handilAdvRetention(
                          invoiceDetails?.journalEntry?.journal_entry_details
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        {invoiceDetails?.voucher_id == 1 ||
        invoiceDetails?.voucher_id == 3 ||
        invoiceDetails?.voucher_id == 6 ||
        invoiceDetails?.voucher_id == 8 ||
        (invoiceDetails?.voucher_id == 13 &&
          invoiceDetails?.voucher_invoice == "Sales Voucher") ||
        (invoiceDetails?.voucher_id == 15 &&
          invoiceDetails?.voucher_invoice == "Purchase Voucher") ||
        (invoiceDetails?.voucher_id == 7 &&
          Number(
            (handilCalaculation2(invoiceDetails?.recipt_note?.materials) *
              Number(invoiceDetails?.vat)) /
              100
          ) == 0) ||
        (invoiceDetails?.voucher_id == 15 &&
          Number(
            handilCalaculationvat(
              invoiceDetails?.journalEntry?.journal_entry_details
            )
          ) == 0) ||
        (invoiceDetails?.voucher_id == 16 &&
          Number(
            (handilCalaculation4(invoiceDetails?.purchaseorder?.materials) *
              Number(invoiceDetails?.vat)) /
              100
          ) == 0) ||
        (invoiceDetails?.voucher_id == 13 &&
          handilVatchange(
            invoiceDetails?.journalEntry?.journal_entry_details
          ) == 0) ||
        (invoiceDetails?.voucher_id == 12 &&
          Number(
            (handilCalaculation5(invoiceDetails?.storeHistory) *
              Number(invoiceDetails?.vat)) /
              100
          ) == 0) ||
        Number(
          handilVatchange(invoiceDetails?.journalEntry?.journal_entry_details)
        ) == 0 ? (
          <></>
        ) : (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">
                    {[
                      "Sales Invoice",
                      "Sales Product Invoice",
                      "Purchase Invoice",
                    ].includes(invoiceDetails?.voucher_invoice)
                      ? "VAT"
                      : ""}
                  </div>
                </Col>

                <Col lg="3" className="py-2">
                  {invoiceDetails?.voucher_id == 7 ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        Number(
                          (handilCalaculation2(
                            invoiceDetails?.recipt_note?.materials
                          ) *
                            Number(invoiceDetails?.vat)) /
                            100
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : invoiceDetails?.voucher_id == 15 &&
                    invoiceDetails?.voucher_invoice == "Purchase Invoice" ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        Number(
                          handilCalaculationvat(
                            invoiceDetails?.journalEntry?.journal_entry_details
                          )
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : invoiceDetails?.voucher_id == 16 ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        Number(
                          (handilCalaculation4(
                            invoiceDetails?.purchaseorder?.materials
                          ) *
                            Number(invoiceDetails?.vat)) /
                            100
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : [13, 18, 4].includes(invoiceDetails?.voucher_id) &&
                    [
                      "Sales Invoice",
                      "Sales Product Invoice",
                      "Purchase Invoice",
                    ].includes(invoiceDetails?.voucher_invoice) ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        handilVatchange(
                          invoiceDetails?.journalEntry?.journal_entry_details
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : invoiceDetails?.voucher_id == 12 ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        Number(
                          (handilCalaculation5(invoiceDetails?.storeHistory) *
                            Number(invoiceDetails?.vat)) /
                            100
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        )}

        {invoiceDetails?.voucher_id == 13 &&
        invoiceDetails?.voucher_invoice == "Sales Product Invoice" &&
        Number(
          handilCalaculationSale(invoiceDetails?.salesvoucher?.materials)
        ) != Number(invoiceDetails?.sub_total) ? (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">Net Total</div>
                </Col>
                <Col lg="3" className="py-2">
                  <div className="text-end pr-28-values">
                    {Number(invoiceDetails?.sub_total).toFixed(desimalrange)}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <></>
        )}

        {([13, 18].includes(invoiceDetails?.voucher_id) &&
          invoiceDetails?.voucher_invoice == "Sales Invoice") ||
        ([15, 4].includes(invoiceDetails?.voucher_id) &&
          invoiceDetails?.voucher_invoice == "Purchase Invoice") ? (
          <Row>
            <Col></Col>
            <Col>
              <Row>
                <Col lg="6"></Col>
                <Col lg="3" className="py-2">
                  <div className="text-end">
                    {invoiceDetails == null ? "" : "Net Total"}
                  </div>
                </Col>
                <Col lg="3" className="py-2">
                  {[13, 18].includes(invoiceDetails?.voucher_id) ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        Number(invoiceDetails?.sub_total),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : invoiceDetails?.voucher_id == 15 ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        Number(
                          handilCalaculation3(
                            invoiceDetails?.purchasevoucher?.materials
                          ) +
                            Number(
                              handilShipingCharg(
                                invoiceDetails?.journalEntry
                                  ?.journal_entry_details
                              )
                            ) +
                            Number(
                              handilOtherCharge(
                                invoiceDetails?.journalEntry
                                  ?.journal_entry_details
                              )
                            ) +
                            Number(
                              handilCalaculationvat(
                                invoiceDetails?.journalEntry
                                  ?.journal_entry_details
                              )
                            ) -
                            Number(
                              handilDiscound15(
                                invoiceDetails?.journalEntry
                                  ?.journal_entry_details
                              )
                            ) +
                            Number(
                              handilVatchange(
                                invoiceDetails?.journalEntry
                                  ?.journal_entry_details
                              )
                            )
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : invoiceDetails?.voucher_id == 4 ? (
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        Number(
                          handilCalaculation3(
                            invoiceDetails?.purchasevoucher?.materials
                          ) +
                            Number(
                              handilShipingCharg(
                                invoiceDetails?.journalEntry
                                  ?.journal_entry_details
                              )
                            ) +
                            Number(
                              handilOtherCharge(
                                invoiceDetails?.journalEntry
                                  ?.journal_entry_details
                              )
                            ) +
                            Number(
                              handilCalaculationvat(
                                invoiceDetails?.journalEntry
                                  ?.journal_entry_details
                              )
                            ) -
                            Number(
                              handilDiscound15(
                                invoiceDetails?.journalEntry
                                  ?.journal_entry_details
                              )
                            ) +
                            Number(
                              handilVatchange(
                                invoiceDetails?.journalEntry
                                  ?.journal_entry_details
                              )
                            )
                        ),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <></>
        )}

        {invoiceDetails?.voucher_id == 16 && (
          <>
            <Row>
              <Col></Col>
              <Col></Col>
            </Row>
            <Row>
              <Col></Col>
              <Col></Col>
            </Row>
            <Row>
              <Col></Col>
              <Col></Col>
            </Row>
            <Row>
              <Col></Col>
            </Row>
            <Row>
              <Col></Col>
              <Col></Col>
            </Row>
            <Row>
              <Col></Col>
              <Col>
                <Row>
                  <Col lg="6"></Col>
                  <Col lg="3" className="py-2">
                    <div className="text-end">Net Total</div>
                  </Col>
                  <Col lg="3" className="py-2">
                    <div className="text-end pr-28-values">
                      {NumberFormat(
                        Number(netTotal16),
                        desimalrange,
                        desimalrange
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        )}
      </Row>

      <Row>
        {invoiceDetails?.narration ? (
          <Col lg={6} md={8} sm={12} className="pb-4">
            <div className="supplier-td-head">Narration</div>
            <div className="supplier-td-body">
              {invoiceDetails ? invoiceDetails?.narration : "-"}
            </div>
          </Col>
        ) : null}
      </Row>
      <Row>
        {invoiceDetails?.purchaseorder?.delivery_terms ? (
          <Col lg={6} md={8} sm={12}>
            <div className="supplier-td-head">Delivery Terms</div>
            <div
              className="supplier-td-body"
              dangerouslySetInnerHTML={{
                __html: invoiceDetails?.purchaseorder?.delivery_terms || "-",
              }}
            />
          </Col>
        ) : null}
      </Row>
      <Row>
        {invoiceDetails?.purchaseorder?.general_terms ? (
          <Col lg={6} md={8} sm={12}>
            <div className="supplier-td-head">General Terms</div>
            <div
              className="supplier-td-body"
              dangerouslySetInnerHTML={{
                __html: invoiceDetails?.purchaseorder?.general_terms || "-",
              }}
            />
          </Col>
        ) : null}
      </Row>
    </>
  )
}

export default DebitAccountVoucherView
